export async function getTwitchBearer() {
  const res = await fetch(
    `https://id.twitch.tv/oauth2/token?client_id=eo09uxd52vln7jis3a4ownnx0skq1k&client_secret=oiej0ibw12toflxbt19t48vsmxd53w&grant_type=client_credentials`,
    { method: "POST" }
  );
  const data = await res.json();
  return data.access_token;
}
